// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-us-section-thirteen {
    background-image: linear-gradient(53deg, #1383c6, #63bd46);
    position: relative;
    z-index: 1;
}
.common-padding {
    margin: 0;
    padding: 80px 0;
}
.section-header-thirteen {
    margin-bottom: 50px;
}
.section-header-thirteen h2 {
    font-size: 36px;
    color: #000000;
    font-weight: 600;
    margin-bottom: 0;
}
.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img {
    text-align: right;
    position: relative;
}
.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img img {
    border-radius: 20px;
}
.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img .choose-us-thirteen-imgone img:nth-child(1) {
    right: -25px;
    bottom: 0;
}
.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img .choose-us-thirteen-imgone img {
    position: absolute;
    z-index: 0;
}
.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img img {
    border-radius: 20px;
}
.choose-us-section-thirteen ul li {
    margin-bottom: 40px;
    transition: 0.5s;
}
.choose-us-section-thirteen ul li .choose-us-content-thirteen {
    display: flex;
}
.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-contents {
    min-width: 50px;
    height: 50px;
    background: #BFE0FE;
    border-radius: 10px;
    font-size: 24px;
    color: #0E82FD;
    margin-right: 16px;
}
.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-content-ryt h5 {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
    margin-bottom: 16px;
}
.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-content-ryt p {
    font-weight: 400;
    letter-spacing: 0.2px;
    margin-bottom: 0;
    color: #374151;
}

.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-contents svg {
  
    margin: 12px 0px 0px 12px;
}

.border-20
{
    border-radius: 20px;
}

.base-page {
    overflow-x: hidden;
}

@media (min-width: 1366px) {
    .base-page-hero {
        min-height: 364px;
    }
}

.base-page-hero {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
    overflow: hidden;
    position: relative;
}

.base-page-hero-bg img {
    height: 100%;
    object-fit: cover;
    object-position: left;
    width: auto;
}
@media (min-width: 1366px) {
    .base-page-hero-content {
        grid-gap: 16px;
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        min-height: 364px;
        padding: unset;
    }
}

@media (min-width: 1366px) {
    .base-page-hero-content-mask {
        grid-column: 1 / 7;
    }
}

.base-page-hero-content-mask {
    padding-bottom: 20px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-image {
        align-self: flex-end;
        display: block;
        grid-column: 7 / 13;
        max-width: unset;
        padding-left: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/career/Career.css"],"names":[],"mappings":"AAAA;IACI,0DAA0D;IAC1D,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,wDAAwD;IACxD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IAEjB,qBAAqB;IACrB,WAAW;AACf;AACA;IACI;QACI,cAAc;QACd,aAAa;QACb,SAAS;QACT,iDAAiD;QACjD,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QAEI,oBAAoB;QACpB,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":[".choose-us-section-thirteen {\n    background-image: linear-gradient(53deg, #1383c6, #63bd46);\n    position: relative;\n    z-index: 1;\n}\n.common-padding {\n    margin: 0;\n    padding: 80px 0;\n}\n.section-header-thirteen {\n    margin-bottom: 50px;\n}\n.section-header-thirteen h2 {\n    font-size: 36px;\n    color: #000000;\n    font-weight: 600;\n    margin-bottom: 0;\n}\n.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img {\n    text-align: right;\n    position: relative;\n}\n.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img img {\n    border-radius: 20px;\n}\n.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img .choose-us-thirteen-imgone img:nth-child(1) {\n    right: -25px;\n    bottom: 0;\n}\n.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img .choose-us-thirteen-imgone img {\n    position: absolute;\n    z-index: 0;\n}\n.choose-us-section-thirteen .choose-us-inner-all .choose-us-thirteen-img img {\n    border-radius: 20px;\n}\n.choose-us-section-thirteen ul li {\n    margin-bottom: 40px;\n    transition: 0.5s;\n}\n.choose-us-section-thirteen ul li .choose-us-content-thirteen {\n    display: flex;\n}\n.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-contents {\n    min-width: 50px;\n    height: 50px;\n    background: #BFE0FE;\n    border-radius: 10px;\n    font-size: 24px;\n    color: #0E82FD;\n    margin-right: 16px;\n}\n.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-content-ryt h5 {\n    font-size: 20px;\n    color: #000000;\n    font-weight: 600;\n    margin-bottom: 16px;\n}\n.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-content-ryt p {\n    font-weight: 400;\n    letter-spacing: 0.2px;\n    margin-bottom: 0;\n    color: #374151;\n}\n\n.choose-us-section-thirteen ul li .choose-us-content-thirteen .chooseus-contents svg {\n  \n    margin: 12px 0px 0px 12px;\n}\n\n.border-20\n{\n    border-radius: 20px;\n}\n\n.base-page {\n    overflow-x: hidden;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero {\n        min-height: 364px;\n    }\n}\n\n.base-page-hero {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n    overflow: hidden;\n    position: relative;\n}\n\n.base-page-hero-bg img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    -o-object-position: left;\n    object-position: left;\n    width: auto;\n}\n@media (min-width: 1366px) {\n    .base-page-hero-content {\n        grid-gap: 16px;\n        display: grid;\n        gap: 16px;\n        grid-template-columns: repeat(12, minmax(0, 1fr));\n        min-height: 364px;\n        padding: unset;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-mask {\n        grid-column: 1 / 7;\n    }\n}\n\n.base-page-hero-content-mask {\n    padding-bottom: 20px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-image {\n        -ms-flex-item-align: end;\n        align-self: flex-end;\n        display: block;\n        grid-column: 7 / 13;\n        max-width: unset;\n        padding-left: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
